import req from './http.js'
import utils from '../plugins/utils'

// 登入
export const apiLogin = params => req('post', '/admin/sys/adminLogin', params)

// 發送重設信件的
export const apiSendResetEmail = params => req('post', '/admin/sys/resetAdminPassword', params)

// 重設密碼&檢查重設密碼信件的token
export const apiResetPwd = params => req('post', '/admin/sys/doResetAdminPwd', params)

// 建立組織
export const apiCreateOrganization = params => req('post', '/admin/org/createOrganization', params)

// 取得組織
export const apiGetOrganization = (params) => {
    const url = utils.makeUrlQuery('/admin/org/getOrganizationList', params)

    return req('get', url).then(function (resp) {
        return resp.data
    }).catch(function (error) {
        throw error
    })
}

// 取得Api列表
export const apiGetApiList = () => req('get', '/admin/auth/getApiList')

// 取得組織的功能模組
export const apiGetSubscriptionInfo = org_id => req('get', `/subscription/info?org=${org_id}`, null).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 取得功能模組
export const apiGetSubscription = () => req('get', `/admin/sys/subscription`, null).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 更新功能模組數量
export const apiUpdateSubscription = params => req('put', '/admin/sys/subscription' , params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 更新功能顯示的名字和備註
export const apiUpdateFeatureName = params => req('patch', '/admin/sys/subscription/name' , params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

//取得 readme列表
export const apiGetReadmeMap = (params) => req('get', `/admin/readmeMap`, params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

//建立 readme
export const apiCreateReadmeMap = (params) => req('post', `/admin/readmeMap`, params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})
// 更新readme
export const apiUpdateReadmeMap = params => req('patch', '/admin/readmeMap' , params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

export const apiGetOrgContainer = (org_id) => req('get', `/admin/org/getOrgContainer?org_id=${org_id}`).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

export const apiUpdateSub = (payload) => req('post', '/admin/org/addSubscription', payload)

export const apiGetProductList = (params) => req('get', `/admin/product?page=${params.page}&limit=${params.limit}`)

export const apiGetOperatorRecord = (params) => {
    const url = utils.makeUrlQuery('/admin/org/getOperatorRecord', params)

    return req('get', url).then(function (resp) {
        return resp.data
    }).catch(function (error) {
        throw error
    })
}

export const apiGetSystemConfig = () => {
    return req('get', '/admin/sys/systemConfig').then(function (resp) {
        return resp.data
    }).catch(function (error) {
        throw error
    })
}

export const apiCreateSystemConfig = (params,id) => {
    return req('post', `/admin/sys/systemConfig?id=${id}`, params).then(function (resp) {
        return resp.data
    }).catch(function (error) {
        throw error
    })
}
